import { render, staticRenderFns } from "./CountryComponent.vue?vue&type=template&id=329ec053&"
import script from "./CountryComponent.vue?vue&type=script&lang=js&"
export * from "./CountryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports